import React, { useState, useEffect } from 'react'
import { Box, Modal, Text } from '@mantine/core'
import { getDetailOrder, deleteOrderHistory } from '../../../../services/orders'
import { getDetailUser } from '../../../../services/users'
import { useParams } from 'react-router-dom'
import { modalDeleteData } from '../../../ui/Prompt/modalDeleteData'
import LoadingData from '../../../ui/LoadingData'
import NoData from '../../../ui/NoData'
import OrderHistoryTable from './LayoutHelper/OrderHistoryTable'
import FormAdjustOrderHistory from './Form/FormAdjustOrderHistory'
import { getAllStatusesList } from '../../../../services/status'

const labelTable = [
  {
    label: 'Created Date',
    width: 'auto'
  },
  {
    label: 'Notified',
    width: 'auto'
  },
  {
    label: 'Order Status',
    width: 'auto'
  },
  {
    label: 'Created By',
    width: 'auto'
  },
  {
    label: 'Message',
    width: 'auto'
  },
  {
    label: 'Additional Note',
    width: 'auto'
  },
  {
    label: 'Action',
    width: 50
  },
]

const OrderStatusHistory = () => {
  const params = useParams()
  const orderId = params.order_id
  const [loading, setLoading] = useState(true)
  const [orderHistoryList, setOrderHistoryList] = useState([])
  const [openModalForm, setOpenModalForm] = useState(false)
  const [detailData, setDetailData] = useState(null)

  const handleGetOrderHistories = async () => {
    setLoading(true)
    const params = {
      include: 'status_histories',
      'fields[order]': 'id',
      sort: 'date'
    }
    try {
      const response = await getDetailOrder(orderId, params)
      if (response.success) {
        const dataHistories = Object.values(response.included.status_histories)
        const remapData = await Promise.all(dataHistories.map(async (val) => {
          const findDataStatus = await handleGetOrderStatusList(val.attributes.status_id)
          if (findDataStatus) {
            return {
              ...val.attributes,
              user: val.attributes.created_by !== 'system' ? await handleGetDetailUser(val.attributes.created_by) : null
            }
          }
        }))
        const filterData = remapData.filter((val) => typeof val === 'object')
        setOrderHistoryList(filterData)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  const handleGetDetailUser = async(userId) => {
    try {
      const response = await getDetailUser(userId)
      const dataUser = response.data.attributes
      const remapData = {
        id: dataUser.id,
        name: dataUser.name
      }
      return remapData
    } catch (error) {
      console.log(error)
    }
  }

  const handleGetOrderStatusList = async (statusId) => {
    const params = {
      'filter[id][is]': statusId,
      'filter[status_type][is]': 2
    }
    try {
      const response = await getAllStatusesList(params)
      return response.success
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    handleGetOrderHistories()
    // eslint-disable-next-line
  }, [])

  const actions = {
    edit: (val) => {
      setOpenModalForm(val)
      setDetailData(val)
    },
    delete: (val) => {
      modalDeleteData('Order History', val.id, val.title, deleteOrderHistory, handleGetOrderHistories)
    },
  }

  const handleAction = (val, type) => {
    return actions[type](val)
  }

  const onCloseFormOrderHistory = () => {
    setOpenModalForm(false)
    setDetailData(null)
  }

  return (
    <Box>
      <Box my={20}>
        {loading ? <LoadingData /> : orderHistoryList.length > 0 ? <OrderHistoryTable label={labelTable} data={orderHistoryList} actionMethod={handleAction} /> : <NoData />}
      </Box>
      <Modal opened={openModalForm} onClose={onCloseFormOrderHistory} centered closeOnClickOutside={false} size='lg' title={<Text fw='Bold'>Update Order Status History</Text>} withCloseButton={false}>
        <FormAdjustOrderHistory dataHistory={detailData} onCloseForm={onCloseFormOrderHistory} reloadList={handleGetOrderHistories} />
      </Modal>
    </Box>
    
  )
}

export default OrderStatusHistory